// Generat automat din README.md
import React from 'react';
import { MessageCircle, Bot, Users, TrendingUp, Clock, Star } from 'lucide-react';
import Card from '../../components/Card';
import Badge from '../../components/Badge';

const Chatbot247 = () => {
  const chatStats = [
    { metric: 'Conversații astăzi', value: '124', change: '+8%' },
    { metric: 'Timp răspuns mediu', value: '2.3s', change: '-15%' },
    { metric: 'Rata rezolvare', value: '87%', change: '+5%' },
    { metric: 'Satisfacție client', value: '4.2/5', change: '+0.3' }
  ];

  const recentChats = [
    { id: 1, customer: 'Ana Popescu', topic: 'Informații preturi', time: '14:30', status: 'Rezolvat', satisfaction: 5 },
    { id: 2, customer: 'Mihai Ionescu', topic: 'Suport tehnic', time: '14:15', status: 'În progres', satisfaction: null },
    { id: 3, customer: 'Elena Georgescu', topic: 'Programare întâlnire', time: '13:45', status: 'Transfer agent', satisfaction: 4 }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Chatbot 24/7</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">
          Asistent virtual inteligent pentru suport client continuu
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {chatStats.map((stat, index) => (
          <Card key={index} title={stat.metric}>
            <div className="text-2xl font-bold text-primary-600">{stat.value}</div>
            <div className={`text-sm ${stat.change.startsWith('+') ? 'text-green-600' : stat.change.startsWith('-') ? 'text-red-600' : 'text-blue-600'}`}>
              {stat.change} față de ieri
            </div>
          </Card>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="Chat Live" subtitle="Vizualizare conversații în timp real" icon={MessageCircle}>
          <div className="h-96 bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
            <div className="space-y-4">
              <div className="flex justify-start">
                <div className="bg-gray-200 dark:bg-gray-600 rounded-lg px-4 py-2 max-w-xs">
                  <div className="flex items-center space-x-2 mb-1">
                    <Bot className="w-4 h-4 text-blue-500" />
                    <span className="text-xs text-gray-500">Chatbot - 14:32</span>
                  </div>
                  <p className="text-sm">Bună ziua! Cu ce vă pot ajuta astăzi?</p>
                </div>
              </div>
              
              <div className="flex justify-end">
                <div className="bg-primary-500 text-white rounded-lg px-4 py-2 max-w-xs">
                  <div className="flex items-center space-x-2 mb-1">
                    <Users className="w-4 h-4" />
                    <span className="text-xs opacity-75">Client - 14:33</span>
                  </div>
                  <p className="text-sm">Aș dori să știu mai multe despre serviciile dumneavoastră.</p>
                </div>
              </div>
              
              <div className="flex justify-start">
                <div className="bg-gray-200 dark:bg-gray-600 rounded-lg px-4 py-2 max-w-xs">
                  <div className="flex items-center space-x-2 mb-1">
                    <Bot className="w-4 h-4 text-blue-500" />
                    <span className="text-xs text-gray-500">Chatbot - 14:33</span>
                  </div>
                  <p className="text-sm">Cu plăcere! Oferim servicii de digitalizare pentru afaceri. Vă pot trimite o broșură detaliată?</p>
                </div>
              </div>
              
              <div className="text-center text-xs text-gray-400 flex items-center justify-center space-x-1">
                <Clock className="w-3 h-3" />
                <span>Conversație activă</span>
              </div>
            </div>
          </div>
        </Card>

        <Card title="Conversații Recente" icon={MessageCircle}>
          <div className="space-y-4">
            {recentChats.map((chat) => (
              <div key={chat.id} className="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-primary-100 dark:bg-primary-900 rounded-full flex items-center justify-center">
                      <Users className="w-4 h-4 text-primary-600" />
                    </div>
                    <div>
                      <p className="font-semibold text-sm">{chat.customer}</p>
                      <p className="text-xs text-gray-500">{chat.topic}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-gray-500">{chat.time}</p>
                    {chat.satisfaction && (
                      <div className="flex items-center space-x-1 mt-1">
                        <Star className="w-3 h-3 text-yellow-500 fill-current" />
                        <span className="text-xs">{chat.satisfaction}</span>
                      </div>
                    )}
                  </div>
                </div>
                <Badge variant={getStatusColor(chat.status)}>{chat.status}</Badge>
              </div>
            ))}
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card title="Configurare Chatbot" icon={Bot}>
          <div className="space-y-4">
            <div className="p-4 border-l-4 border-blue-500 bg-blue-50 dark:bg-blue-900/20">
              <h4 className="font-semibold text-blue-800 dark:text-blue-200">Răspunsuri Automate</h4>
              <p className="text-blue-700 dark:text-blue-300 text-sm mt-1">
                245 răspunsuri predefinite active
              </p>
              <button className="text-xs text-blue-600 hover:text-blue-800 mt-2">Editează răspunsurile</button>
            </div>
            
            <div className="p-4 border-l-4 border-green-500 bg-green-50 dark:bg-green-900/20">
              <h4 className="font-semibold text-green-800 dark:text-green-200">Inteligență Artificială</h4>
              <p className="text-green-700 dark:text-green-300 text-sm mt-1">
                Model antrenat cu 12,000+ conversații
              </p>
              <button className="text-xs text-green-600 hover:text-green-800 mt-2">Antrenează modelul</button>
            </div>
            
            <div className="p-4 border-l-4 border-purple-500 bg-purple-50 dark:bg-purple-900/20">
              <h4 className="font-semibold text-purple-800 dark:text-purple-200">Escaladare Automată</h4>
              <p className="text-purple-700 dark:text-purple-300 text-sm mt-1">
                Transfer către agent uman după 3 întrebări complexe
              </p>
              <button className="text-xs text-purple-600 hover:text-purple-800 mt-2">Configurează reguli</button>
            </div>
          </div>
        </Card>

        <Card title="Analiză Performance" icon={TrendingUp}>
          <div className="space-y-6">
            <div className="space-y-3">
              <div className="flex justify-between text-sm">
                <span>Întrebări frecvente</span>
                <span className="font-semibold">78%</span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                <div className="bg-green-500 h-2 rounded-full" style={{width: '78%'}}></div>
              </div>
            </div>
            
            <div className="space-y-3">
              <div className="flex justify-between text-sm">
                <span>Probleme tehnice</span>
                <span className="font-semibold">45%</span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                <div className="bg-yellow-500 h-2 rounded-full" style={{width: '45%'}}></div>
              </div>
            </div>
            
            <div className="space-y-3">
              <div className="flex justify-between text-sm">
                <span>Cereri complexe</span>
                <span className="font-semibold">23%</span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                <div className="bg-red-500 h-2 rounded-full" style={{width: '23%'}}></div>
              </div>
            </div>
            
            <div className="pt-4 border-t border-gray-200 dark:border-gray-600">
              <div className="text-sm space-y-2">
                <div className="flex justify-between">
                  <span>Îmbunătățiri sugerate:</span>
                </div>
                <ul className="text-xs text-gray-600 dark:text-gray-400 space-y-1">
                  <li>• Adaugă răspunsuri pentru probleme de conectivitate</li>
                  <li>• Îmbunătățește recunoașterea intenției pentru prețuri</li>
                  <li>• Creează flow pentru programări automate</li>
                </ul>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

// Helper function pentru culori status
const getStatusColor = (status) => {
  const colors = {
    'Rezolvat': 'success',
    'În progres': 'warning',
    'Transfer agent': 'info',
    'Anulat': 'error'
  };
  return colors[status] || 'default';
};

export default Chatbot247;